/**
 * Created by Ning Jiang on 11/22/2016.
 */

import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {WildNudgeGameModuleConfig} from "./WildNudgeGameModuleConfig";

export class WildNudge extends SlotGame {

    constructor() {
        super(WildNudgeGameModuleConfig.instance);
    }

    getNoWinGameData():any {
        return {
            "reels": [
                [
                    "L3",
                    "M1",
                    "M1",
                    "M1",
                    "M1",
                    "L4"
                ],
                [
                    "M1",
                    "L4",
                    "L4",
                    "L2",
                    "L2",
                    "L1"
                ],
                [
                    "L2",
                    "L2",
                    "L1",
                    "L1",
                    "L3",
                    "L3"
                ],
                [
                    "M2",
                    "M2",
                    "M2",
                    "L4",
                    "L4",
                    "L3"
                ],
                [
                    "L3",
                    "M3",
                    "M3",
                    "M3",
                    "M3",
                    "L2"
                ]
            ],
            "evaluatedArea": [
                [
                    "M1",
                    "M1",
                    "M1",
                    "M1"
                ],
                [
                    "L4",
                    "L4",
                    "L2",
                    "L2"
                ],
                [
                    "L2",
                    "L1",
                    "L1",
                    "L3"
                ],
                [
                    "M2",
                    "M2",
                    "L4",
                    "L4"
                ],
                [
                    "M3",
                    "M3",
                    "M3",
                    "M3"
                ]
            ],
            "betLineWins": [],
            "totalBetLineWinnings": 0,
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 2,
            "nearWinReels": [
                false,
                false,
                false,
                false,
                false
            ],
            "reelsNextSpin": "BASE_REELSET",
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "currentMultiplier": 1,
            "freespinTriggeredThisSpin": false,
            "activeStackedSymbol": "",
            "stackedSpinTriggered": false,
            "initialStackOverlay": [
                false,
                false,
                false,
                false,
                false
            ],
            "stackOverlay": [
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "numberOfFreespinsPlayed": 0,
            "freespinsLeft": 0,
            "addedNumberOfFreespinsThisSpin": 0,
            "overlayWilds": [
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "doReelNudge": [
                false,
                false,
                false,
                false,
                false
            ],
            "doScatterNudge": [
                false,
                false,
                false,
                false,
                false
            ],
            "extraSymbolsOnTop": [
                [
                    "L1",
                    "L4",
                    "L4",
                    "L3"
                ],
                [
                    "L3",
                    "M1",
                    "M1",
                    "M1"
                ],
                [
                    "M1",
                    "L3",
                    "L3",
                    "S"
                ],
                [
                    "L3",
                    "L3",
                    "S",
                    "M2"
                ],
                [
                    "M1",
                    "L4",
                    "L4",
                    "L3"
                ]
            ],
            "stackedSymbolNudgeTriggered": false,
            "scatterPositions": [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "stackedModeSymbolInWin": [
                false,
                false,
                false,
                false,
                false
            ],
            "nearWinBigWinReels": [
                false,
                false,
                false,
                false,
                false
            ]
        };
    }
}